"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DatePickerView = void 0;

var _styled = _interopRequireDefault(require("@emotion/styled"));

var _templateObject;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var DatePickerView = _styled.default.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  ", "\n\n  background-color: rgba(0, 0, 0, 0.04);\n  padding: 8px 15px 12px;\n  margin-bottom: 10px;\n  border-bottom: 1px solid ", ";\n  border-radius: 4px 4px 0 0;\n  box-sizing: border-box;\n\n  .datepicker {\n    border: none;\n    background-color: #f3f6f9;\n    color: #464e5f;\n    width: 100%;\n    outline: none;\n  }\n\n  .datepicker-wrapper {\n    display: block;\n    margin-bottom: 0;\n  }\n\n  .datepicker-label {\n    font-size: 12px;\n    color: ", ";\n    letter-spacing: 0.4px;\n  }\n\n  .form-grp {\n    margin-bottom: 1.75rem;\n  }\n\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__month-text--keyboard-selected,\n  .react-datepicker__quarter-text--keyboard-selected {\n    background-color: ", ";\n  }\n"])), function (_ref) {
  var wrapperStyle = _ref.wrapperStyle;
  return wrapperStyle;
}, function (_ref2) {
  var color = _ref2.color;
  return color;
}, function (_ref3) {
  var color = _ref3.color;
  return color;
}, function (_ref4) {
  var color = _ref4.color;
  return color;
});

exports.DatePickerView = DatePickerView;

//# sourceMappingURL=CustomDatePicker.style.js.map